<template>
  <div class="block">
    <div class="el-descriptions__title sky-hc-software-list__title">
      <div>
        {{ $t('whitelist.softSituation') }}
        <span
          class="sky-hc-software-list__desc"
          v-if="softwareList.length !== 0 && whiteList.length !== 0"
          v-html="
            $t('whitelist.softwareSituation', {
              total: `<span class='bold bold--big'> ${softwareList.length} </span>`,
              allow: `<span class='green-color green-color--big'> ${whiteList.length} </span>`,
              uninstall: `${
                softwareList.length - whiteList.length
                  ? $t('whitelist.uninstallSoft', {
                      num: '<span class=' + 'grey-color> ' + (softwareList.length - whiteList.length) + ' </span>'
                    })
                  : ''
              }`
            })
          "
        ></span>
        <span
          class="sky-hc-software-list__desc"
          v-if="softwareList.length !== 0 && whiteList.length === 0"
          v-html="getNoWhiteListTip(softwareList.length)"
        ></span>
        <span class="sky-hc-software-list__desc" v-if="softwareList.length === 0">{{
          $t('whitelist.unUseWhitelist')
        }}</span>
        <el-tooltip v-if="softwareList.length !== 0" placement="top" effect="light">
          <div slot="content" class="sky-hc-software-list__tooltip-txt">
            <span class="sky-hc-software-list__color-green">绿色</span>代表允许使用的装软件；<span
              class="sky-hc-software-list__color-opacity-green"
              >透明绿色</span
            >代表已被卸载的软件；<span class="sky-hc-software-list__color-grey">灰色</span>代表禁止运行的软件。
          </div>
          <span class="sky-hc-software-list__tip-text">查看颜色含义</span>
        </el-tooltip>
      </div>
      <span v-if="hasSeeMore" class="sky-hc-software-list__see-more" @click="handleSeeMore">{{
        $t('activeOrg.seeWhiteList')
      }}</span>
    </div>
    <div ref="tagsWrapper" class="sky-hc-software-list__tags-wrapper">
      <div ref="actualTags" class="sky-hc-software-list__tags">
        <div v-for="(item, index) in softwareList" class="sky-hc-software-list__tag-item" :key="'00' + index">
          <el-tag
            :type="item.isWhitelist ? 'success' : 'grey'"
            :class="{ 'sky-hc-software-list__tag-item--uninstall': item.isUninstall }"
            >{{ item.label }}</el-tag
          >
        </div>
      </div>
    </div>
    <div class="sky-hc-software-list__btn-wrapper" v-if="hasMoreTags">
      <el-button class="sky-hc-software-list__btn-more" @click="showMoreSoftware">{{
        $t('whitelist.loadMore')
      }}</el-button>
    </div>
  </div>
</template>
<script>
import { Tag, Button } from 'element-ui'

import { getSoftwareList } from '@/api/whitelist'
export default {
  name: 'SoftwareSituation',
  components: {
    [Tag.name]: Tag,
    [Button.name]: Button
  },
  props: {
    orgId: {
      type: String,
      default() {
        return ''
      }
    },
    hasSeeMore: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      softwareList: [],
      whiteList: [],
      uninstallNum: 0,
      hasMoreTags: false
    }
  },
  watch: {
    orgId() {
      this.hasMoreTags = false
      this.handleGetSoftwareList()
    }
  },
  created() {
    this.hasMoreTags = false
    this.handleGetSoftwareList()
  },
  methods: {
    handleGetSoftwareList() {
      getSoftwareList({
        id: this.orgId
      }).then(response => {
        const data = response.data.content
        data.orgAllowSoftwareList = data.orgAllowSoftwareList ? data.orgAllowSoftwareList : []
        data.totalSoftware = data.totalSoftware ? data.totalSoftware : []
        // this.openButNoSoft = data.tag
        let whitelistSoftware = [...data.orgAllowSoftwareList]
        let totalSoftware = [...data.totalSoftware]
        let resSoftwareArr = []
        let num = 0
        totalSoftware.map(item => {
          if (whitelistSoftware.length > 0) {
            const index = whitelistSoftware.indexOf(item)
            if (index > -1) {
              whitelistSoftware.splice(index, 1)
              resSoftwareArr.splice(num, 0, {
                label: item,
                isWhitelist: true,
                isUninstall: false
              })
              num++
            } else {
              resSoftwareArr.push({
                label: item,
                isWhitelist: false,
                isUninstall: false
              })
            }
          } else {
            resSoftwareArr.push({
              label: item,
              isWhitelist: data.orgAllowSoftwareList.length === 0,
              isUninstall: false
            })
          }
        })
        if (whitelistSoftware.length > 0) {
          let unInstallArr = whitelistSoftware.map(item => {
            return {
              label: item,
              isWhitelist: true,
              isUninstall: true
            }
          })
          this.uninstallNum = unInstallArr.length
          resSoftwareArr.splice(num, 0, ...unInstallArr)
        }
        this.softwareList = resSoftwareArr ? resSoftwareArr : []
        this.whiteList = data.orgAllowSoftwareList
        // 处理是否显示加载更多软件问题
        this.handleMore()
      })
    },
    handleMore() {
      this.$nextTick(() => {
        const actualTags = this.$refs.actualTags
        const tagsWrapper = this.$refs.tagsWrapper
        console.log()
        if (actualTags && tagsWrapper) {
          console.log(
            tagsWrapper.clientHeight < actualTags.clientHeight,
            tagsWrapper.clientHeight,
            actualTags.clientHeight
          )
          if (tagsWrapper.clientHeight < actualTags.clientHeight) {
            this.hasMoreTags = true
          } else {
            this.hasMoreTags = false
          }
        }
      })
    },
    showMoreSoftware() {
      this.hasMoreTags = false
      this.$refs.tagsWrapper.style.maxHeight = 'fit-content'
    },
    handleSeeMore() {
      this.$emit('handleSeeMore')
    },
    getNoWhiteListTip(num) {
      return this.whitelistInfo?.whiteListTerminalGroupCount
        ? this.$t('whitelist.softwareSituationAllow', {
            total: `<span class='bold bold--big'> ${num} </span>`
          })
        : this.$t('whitelist.softwareSituationAllow2', {
            total: `<span class='bold bold--big'> ${num} </span>`
          })
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-software-list) {
  @include e(tags) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  @include e(tag-item) {
    margin-right: 10px;
    margin-bottom: 6px;
    @include m(uninstall) {
      opacity: 0.3;
    }
  }
  @include e(desc) {
    font-weight: normal;
  }
  @include e(see-more) {
    color: $--color-primary;
    cursor: pointer;
    font-size: $--size-base;
  }
  @include e(title) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  @include e(color-green) {
    color: #fff;
    margin-right: 2px;
    padding: 2px 8px;
    border-radius: 16px;
    background: $--color-success;
  }
  @include e(color-opacity-green) {
    color: #fff;
    margin-right: 2px;
    padding: 2px 8px;
    border-radius: 16px;
    background: $--color-success;
    opacity: 0.3;
  }
  @include e(color-grey) {
    color: #909399 !important;
    border-radius: 16px;
    margin-right: 2px;
    padding: 2px 8px;
    background-color: #f4f4f5 !important;
    border: 1px solid #e9e9eb;
  }
  @include e(tip-text) {
    color: $--color-primary;
    font-size: $--size-base;
    cursor: pointer;
  }
  @include e(tooltip-txt) {
    color: $--color-grey-8;
    line-height: 24px;
  }
  @include e(btn-wrapper) {
    display: flex;
    width: 100%;
    justify-content: center;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  @include e(btn-more) {
    margin-left: 0px !important;
  }
  @include e(tags-wrapper) {
    max-height: 310px;
    overflow: hidden;
  }
}
.el-tag--grey {
  background-color: #f4f4f5 !important;
  border-color: #e9e9eb !important;
  color: #909399 !important;
}
.grey-color {
  color: #909399;
  font-weight: bold;
}
</style>
